function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Select, InputNumber } from "antd";
import { Container, Row, Col } from 'react-bootstrap';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var AddBusinessAccountItem = function AddBusinessAccountItem(_ref) {
  var handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    deptOptions = _useState8[0],
    setDeptOptions = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    serviceOptions = _useState0[0],
    setServiceOptions = _useState0[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    serviceList = _useState10[0],
    setServiceList = _useState10[1];
  var handleBasePriceChange = function handleBasePriceChange(v) {
    form.setFieldsValue({
      ent_price: v.target.value,
      ins_price: v.target.value,
      lan_price: v.target.value
    });
  };
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append('label', values.label);
    formData.append('department_id', values.department_id);
    formData.append("business_account_medical_item_category_id", values.business_account_medical_item_category_id);
    formData.append('base_price', values.base_price);
    formData.append('ent_price', values.ent_price);
    formData.append('ins_price', values.ins_price);
    formData.append('standard', values.standard);
    formData.append("user_id", Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addbusinessaccountitem', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getdepartments').then(function (response) {
      if (response.data.status == 200) {
        response.data.departments.forEach(function (s) {
          setDeptOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: s.id,
              label: s.label
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, []);
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getbusinessaccountmedicalitemcategories/" + Common.currentUser.id).then(function (response) {
      setServiceOptions([]);
      setServiceList([]);
      if (response.data.status == 200) {
        response.data.categories.forEach(function (c) {
          setServiceList(function (prev) {
            return [].concat(_toConsumableArray(prev), [c]);
          });
        });
      }
    })["catch"](function (error) {})["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      form: form,
      onFinish: onFinish,
      children: [formError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: formError,
          showIcon: true
        })
      }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: formSuccess,
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "label",
        label: "Nom de l'acte/Produit",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "base_price",
            label: "prix de base",
            onChange: handleBasePriceChange,
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "ent_price",
            label: "prix soci\xE9t\xE9s",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "ins_price",
            label: "prix assurances",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "department_id",
            label: "Service",
            children: /*#__PURE__*/_jsx(Select, {
              placeholder: "Choisir le service",
              options: deptOptions,
              onChange: function onChange(v) {
                setServiceOptions([]);
                serviceList.filter(function (s) {
                  return s.department_id == v;
                }).forEach(function (ss) {
                  setServiceOptions(function (prev) {
                    return [].concat(_toConsumableArray(prev), [{
                      value: ss.id,
                      label: ss.label
                    }]);
                  });
                });
              },
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }]
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          sm: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "business_account_medical_item_category_id",
            label: "Service",
            children: /*#__PURE__*/_jsx(Select, {
              placeholder: "Choisir la cat\xE9gorie",
              options: serviceOptions,
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }]
            })
          })
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "standard",
        label: "Norme",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          htmlType: "submit",
          disabled: deptOptions.length == 0,
          loading: isFormLoading,
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "AJOUTER"
          })
        })
      })]
    })
  });
};
export default AddBusinessAccountItem;